module.exports = __webpack_public_path__ + "img/tea6.e7617ebe.png";